import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import HeaderPage from '../components/HeaderPage';
import Footer from '../components/Footer';
import { useBlogContext } from '../../fetchdata/BlogContext';
import CreateSlug from '../components/extra/CreateSlug';
import Header from '../components/Header';

const CartPage = () => {

  const {
    cartItems,
    removeItemFromCart,
    updateItemQuantity,
    removePromoCode,
    applyPromoCode,
    promoCodeInfo,
    mypromoCode,
    totalAmount
  } = useBlogContext();

  const [promoCode, setPromoCode] = useState('');

  const handleRemovePromoCode = () => {
    toast.success('Promo code removed');
    removePromoCode();
  };

  const handleApplyPromoCode = () => {
    applyPromoCode(promoCode);
  };

  const handleDecreaseQuantity = (itemId) => {
    updateItemQuantity(itemId, cartItems.find(item => item.id === itemId).quantity - 1);
  };

  const handleIncreaseQuantity = (itemId) => {
    updateItemQuantity(itemId, cartItems.find(item => item.id === itemId).quantity + 1);
  };

  return (
    <>
      <Header />

      <main className="page-content mypadding bg-light pb-4 px-0">
        <div className="container pb-4 mt-4">
          <div className="row g-4 cart-desktop-layout">

            {/* ================= LEFT : CART ITEMS ================= */}
            <div className="col-12 col-lg-8">

              {cartItems && cartItems.length > 0 ? (
                <div className="border rounded-3 bg-white p-2">
                  <table className="table table-hover carttable m-0">
                    <thead>
                      <tr>
                        <th>Image</th>
                        <th>Name</th>
                        <th>Price</th>
                      </tr>
                    </thead>
                    <tbody>
                      {cartItems.map((item) => {
                        const myslug = CreateSlug(item.title);
                        return (
                          <tr key={item.id}>
                            <td>
                              <Link to={`/product/${myslug}/`}>
                                <img
                                  src={item.image}
                                  alt={item.title}
                                  style={{
                                    width: 90,
                                    aspectRatio: "1 / 1",
                                    objectFit: "contain"
                                  }}
                                />
                              </Link>
                            </td>

                            <td>
                              <p className="mb-1 text-truncate" style={{ maxWidth: 220 }}>
                                {item.title}
                              </p>

                              <div className="d-flex gap-2 align-items-center mt-2">
                                <button
                                  className="btn btn-primary btn-sm"
                                  disabled={promoCodeInfo && promoCodeInfo.discount}
                                  onClick={() => handleDecreaseQuantity(item.id)}
                                >−</button>

                                <span>{item.quantity}</span>

                                <button
                                  className="btn btn-primary btn-sm"
                                  disabled={promoCodeInfo && promoCodeInfo.discount}
                                  onClick={() => handleIncreaseQuantity(item.id)}
                                >+</button>
                              </div>
                            </td>

                            <td>
                              <p className="mb-2">₹{item.quantity * item.price}</p>
                              <button
                                className="btn btn-danger btn-sm w-100"
                                onClick={() => removeItemFromCart(item.id)}
                              >
                                Remove
                              </button>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              ) : (
                <div className="text-center mt-5">
                  <img src="/assets/img/product-not-found.png" alt="no cart" style={{ maxWidth: 200 }} />
                  <p className="h4 fw-light mt-3">No items in the cart</p>
                  <Link className="btn btn-primary w-50 mt-3" to="/">Shop Now</Link>
                </div>
              )}
            </div>

            {/* ================= RIGHT : SUMMARY ================= */}
            {cartItems && cartItems.length > 0 && (
              <div className="col-12 col-lg-4">
                <div className="card border cart-summary">
                  <div className="card-body">

                    {promoCodeInfo && promoCodeInfo.discount ? (
                      <>
                        <div className="d-flex justify-content-between">
                          <span>Sub Total</span>
                          <span>
                            ₹{cartItems.reduce((t, i) => t + i.quantity * i.price, 0)}
                          </span>
                        </div>

                        <div className="d-flex justify-content-between">
                          <span>Discount</span>
                          <span>
                            ₹{totalAmount -
                              cartItems.reduce((t, i) => t + i.quantity * i.price, 0)}
                          </span>
                        </div>

                        <hr />

                        <div className="d-flex justify-content-between fw-bold">
                          <span>Total</span>
                          <span>₹{totalAmount}</span>
                        </div>

                        <div className="mypromobox d-flex justify-content-between align-items-center mt-3">
                          <p className="m-0">
                            <b>{mypromoCode}</b> applied
                          </p>
                          <button className="btn btn-danger btn-sm" onClick={handleRemovePromoCode}>
                            Remove
                          </button>
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="d-flex justify-content-between fw-bold">
                          <span>Total</span>
                          <span>
                            ₹{cartItems.reduce((t, i) => t + i.quantity * i.price, 0)}
                          </span>
                        </div>

                        <hr />

                        <div className="input-group mb-3">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Promo code"
                            value={promoCode}
                            onChange={(e) => setPromoCode(e.target.value)}
                          />
                          <button className="btn btn-primary" onClick={handleApplyPromoCode}>
                            Apply
                          </button>
                        </div>
                      </>
                    )}

                    <Link className="btn btn-primary w-100 mt-3" to="/checkout">
                      Checkout
                    </Link>

                  </div>
                </div>
              </div>
            )}

          </div>
        </div>
      </main>

      <Footer />
    </>
  );
};

export default CartPage;
